import PopoverMessageCheckbox from './popover-message-checkbox';

export default PopoverMessageCheckbox;
